import React from 'react';

import Container from './Container.js';

import './Window.css';

export default class Window extends React.Component {

  constructor(props) {
    super(props);

    this.window = true;
    this.parent = this.props.parent;

    const props1 = this.onProps();
    const props2 = this.props;

    const title = props1.title || props2.title;
    const draggable = props1.draggable || props2.draggable;
    const resizeable = props1.resizeable || props2.resizeable;
    const startPosition = props1.startPosition || props2.startPosition;

    const width = props1.width || props2.width || 0.2 * this.parent.state.width;
    const height = props1.height || props2.height || 0.2 * this.parent.state.height;

    this.state = {
      title, draggable, resizeable, startPosition, width, height,
      zIndex: 0
    }
    this.setPosition();

  }

  setPosition() {
    const startPos = this.state.startPosition;
    let x,y;
    if(!this.props.position) {
      if(startPos) {
        const w = this.parent.state.width, h = this.parent.state.height;
        switch(startPos) {
          case 'center':
            x = w / 2 - this.state.width / 2;
            y = h / 2 - this.state.height / 2;
            break;
          case 'topLeft':
            x = 0;
            y = 0;
            break;
          case 'topRight':
            x = w - this.state.width;
            y = 0;
            break;
          case 'bottomLeft':
            x = 0;
            y = h - this.state.height;
            break;
          case 'bottomRight':
            x = w - this.state.width;
            y = h - this.state.height;
            break;
          default:
            break;
        }
      } else {
        x = 0;
        y = 0;
      }
    } else {
      x = this.props.position.x;
      y = this.props.position.y;
    }
    this.state.position = {
      x, y
    }
  }

  updatePosition(x, y) {
    this.onMove();
    this.setState({
      position: {x,y}
    });
  }

  componentDidMount() {
    this.windowNode = this.refs.windowComponent;
    this.registerEvents();
  }

  registerEvents() {
    const WindowNode = this.windowNode;
    const Head = WindowNode.children[0];
    const CloseBtn = Head.children[1];
    this.events = [];
    if(this.state.draggable) {
      Head.addEventListener('mousedown', this.headBeingDrag.bind(this));
      document.addEventListener('mousemove', this.mouseMove.bind(this));
      document.addEventListener('mouseup', this.mouseUp.bind(this));
    } else {
      Head.removeEventListener('mousedown', this.headBeingDrag.bind(this));
    }

    // Handle close button click
    CloseBtn.addEventListener('click', this.closeWindow.bind(this));
    // Handle selection
    WindowNode.addEventListener('mousedown', this.showAtTop.bind(this));

  }

  showAtTop() {
    //unTop others windows
    this.parent.childsToComponents().forEach(component => {
      if(component.window) {
        component.unTop();
      }
    });
    this.setState({
      zIndex: '100'
    });
  }

  unTop() {
    // Keep order, it works!
    this.setState({
      zIndex: this.state.zIndex > 0 ? this.state.zIndex - 10 : 0
    });
  }

  closeWindow() {
    // Not really close it, but remove it from the rendered objects, sort of a hide
    this.fadeOut().then(() => {
      this.parent.removeChild(this);
    });
  }

  fadeOut() {
    return new Promise((resolve) => {
      const WindowNode = this.windowNode;
      WindowNode.className += " fadeOut";
      setTimeout(resolve, 200);
    });
  }

  headBeingDrag(e) {
    const x = e.clientX, y = e.clientY;
    this.events['drag'] = {
      dragging: true,
      start: {
        x,y
      },
      offset: {
        x: this.state.position.x,
        y: this.state.position.y
      }
    };
  }

  componentDidUpdate() {
    this.parent.updateChild(this.props.index, this);
  }

  mouseMove(e) {
    const mouseX = e.clientX, mouseY = e.clientY;
    const event = this.events['drag'];
    if(event && event.dragging) {
      e.preventDefault();
      const start = event.start;
      let x = mouseX - start.x + event.offset.x,
            y = mouseY - start.y + event.offset.y;
      if(x + this.state.width > this.parent.state.width)
        x = this.parent.state.width - this.state.width;
      if(y + this.state.height > this.parent.state.height)
        y = this.parent.state.height - this.state.height;
      if(x < 0)
        x = 0;
      if(y < 0)
        y = 0;
      this.updatePosition(x, y);
    }
  }

  mouseUp(e) {
    const event = this.events['drag'];
    if(event) {
      if(event.dragging) {
        event.dragging = false;
        this.onEndMove();
      }
    }
  }

  onRender() {} // Method for classes that extends Window

  onProps() {
    return {}
  } // Method for classes that extends Window

  onMove() {
    this.updateChilds();
  }

  onEndMove() {
    this.updateChilds();
  }

  updateChilds() {
    const childs = this.getChilds();
    if(childs) {
      childs.forEach(child => {
        if(child.ref) {
          const component = this.refs[child.ref];
          if(component && component.onUpdate)
            component.onUpdate();
        }
      })
    }
  }

  getChilds() {
    const childs1 = this.props.children;
    const childs2 = this.onRender();

    let childs = [];
    if(childs1) childs.push(childs1);
    if(childs2) childs.push(childs2);

    return childs;
  }

  render() {
    const _closeBtnSize = 15;
    const position = this.state.position;
    return (
      <div style={{width: this.state.width, height: this.state.height, left: position.x, top: position.y, zIndex: this.state.zIndex}} className={"Window" + (this.props.className ? " " + this.props.className : "")} ref='windowComponent'>
        <div className="Head">
          <div className="Title">
            {this.state.title}
          </div>
          <div className="CloseBtn">
            <svg width={_closeBtnSize} height={_closeBtnSize}>
              <path d={"M0,0 L" + _closeBtnSize + ","+_closeBtnSize+" M0,"+_closeBtnSize+" L"+_closeBtnSize+",0"} stroke={'white'} strokeWidth={1}/>
            </svg>
          </div>
        </div>
        <Container className="Body">
          <div>
            {this.getChilds()}
          </div>
        </Container>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/windows/Window.js